const environments = {
    development: {
        // 开发1环境
        // baseURL: 'http://192.168.1.177:1211',
        // uploadBaseUrl: 'http://192.168.1.177:1211/upload/single',
        // fddUploadBaseUrl: 'http://192.168.1.177:1211/upload/single/fdd',
        // multiUploadBaseUrl: "http://192.168.1.177:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',
         
        // baseURL: 'http://192.168.1.19:1211',
        // uploadBaseUrl: 'http://192.168.1.19:1211/upload/single',
        // fddUploadBaseUrl: 'http://192.168.1.19:1211/upload/single/fdd',
        // multiUploadBaseUrl: "http://192.168.1.19:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',

        // //测试2
        // baseURL: 'http://192.168.1.183:1211',
        // uploadBaseUrl: 'http://192.168.1.183:1211/upload/single',
        // fddUploadBaseUrl: 'http://192.168.1.183:1211/upload/single/fdd',
        // multiUploadBaseUrl: "http://192.168.1.183:1211/upload/batch",
        // fileUrl: 'https://img2.9000ji.com',

        //测试1环境
        baseURL: 'http://bakgateway.btstars.cn',
        uploadBaseUrl: 'http://bakgateway.btstars.cn/upload/single',
        fddUploadBaseUrl: 'http://bakgateway.btstars.cn/upload/single/fdd',
        multiUploadBaseUrl: "http://bakgateway.btstars.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com'

        // baseURL: 'http://pregateway.fanxingtiaodong.com',
        // uploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single',
        // fddUploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single/fdd',
        // multiUploadBaseUrl: "http://pregateway.fanxingtiaodong.com/upload/batch",
        // fileUrl: 'https://img2.9000ji.com'
        
        // baseURL: 'https://gateway.jxfxtd.com',
        // uploadBaseUrl: 'https://gateway.jxfxtd.com/upload/single',
        // fddUploadBaseUrl: 'https://gateway.jxfxtd.com/upload/single/fdd',
        // multiUploadBaseUrl: "https://gateway.jxfxtd.com/upload/batch",
        // fileUrl: 'https://img2.9000ji.com'
        

    },
    // 开发2环境
    developmentTwo: {
        baseURL: 'http://192.168.1.19:1211',
        uploadBaseUrl: 'http://192.168.1.19:1211/upload/single',
        fddUploadBaseUrl: 'http://192.168.1.19:1211/upload/single/fdd',
        multiUploadBaseUrl: "http://192.168.1.19:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
    },
    testing: {
        baseURL: 'http://192.168.1.177:1211',
        uploadBaseUrl: 'http://192.168.1.177:1211/upload/single',
        fddUploadBaseUrl: 'http://192.168.1.177:1211/upload/single/fdd',
        multiUploadBaseUrl: "http://192.168.1.177:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
    },
    
    testingtwo: {
        baseURL: 'http://192.168.1.183:1211',
        uploadBaseUrl: 'http://192.168.1.183:1211/upload/single',
        fddUploadBaseUrl: 'http://192.168.1.183:1211/upload/single/fdd',
        multiUploadBaseUrl: "http://192.168.1.183:1211/upload/batch",
        fileUrl: 'https://img2.9000ji.com',
    },
    //测试1环境
    testingOne: {
        baseURL: 'http://bakgateway.btstars.cn',
        uploadBaseUrl: 'http://bakgateway.btstars.cn/upload/single',
        fddUploadBaseUrl: 'http://bakgateway.btstars.cn/upload/single/fdd',
        multiUploadBaseUrl: "http://bakgateway.btstars.cn/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
    },
    //预发布
    prerelease: {
        baseURL: 'http://pregateway.fanxingtiaodong.com',
        uploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single',
        fddUploadBaseUrl: 'http://pregateway.fanxingtiaodong.com/upload/single/fdd',
        multiUploadBaseUrl: "http://pregateway.fanxingtiaodong.com/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
    },
    //线上
    production: {
        baseURL: 'https://gateway.jxfxtd.com',
        uploadBaseUrl: 'https://gateway.jxfxtd.com/upload/single',
        fddUploadBaseUrl: 'https://gateway.jxfxtd.com/upload/single/fdd',
        multiUploadBaseUrl: "https://gateway.jxfxtd.com/upload/batch",
        fileUrl: 'https://img2.9000ji.com'
    }
};
export default environments

